module.exports = __webpack_public_path__ + "static/media/outline-icons.82f60bd0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/outline-icons.svg
// module id = 411
// module chunks = 0